import React from 'react';
import styled from 'styled-components';
import { LuHandshake } from 'react-icons/lu';
import Layout from './Layout';
import { colors } from '../styles/colors';

const StatusContainer = styled.div`
  background: white;
  border-radius: 8px;
  padding: 64px 32px;
  max-width: 500px;
  width: 100%;
  min-height: 555px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 32px 24px;
  }
`;

const IconWrapper = styled.div`
  margin: 0 auto 32px;
  display: flex;
  justify-content: center;
`;

const StatusTitle = styled.h1`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
  color: ${colors.text};
`;

const StatusMessage = styled.p`
  font-size: 14px;
  color: ${colors.textLight};
`;

const RespondedPage = () => {
  return (
    <Layout>
      <StatusContainer>
        <IconWrapper>
          <LuHandshake size={80} color="#0098BB" strokeWidth={1.2} />
        </IconWrapper>
        <StatusTitle>すでに対応されています</StatusTitle>
        <StatusMessage>この画面は閉じてください。</StatusMessage>
      </StatusContainer>
    </Layout>
  );
};

export default RespondedPage;
